<template>
  <div class="discussion_mng">
    <h2 class="title_com">讨论组管理</h2>
    <section class="pd2430">
      <div class="header-title">
        学员共自发组织讨论{{ discussionHeaderData.discuss_num }}个，发言量为{{
          discussionHeaderData.discuss_speak_num
        }}
      </div>
      <!-- 搜索 -->
      <MySearch
        :list1="typeOptions"
        :triggerPhName="8"
        :triggerPhName2="8"
        :showLabel1="8"
        :show2="0"
        :show3="0"
        :showIpt2="1"
        @changeVal="changeVal"
        @requestCommonFn="requestCommonFn"
        @resetPage="resetPage"
      ></MySearch>

      <!-- 表格 -->
      <el-table
        :data="postList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          height: '50px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mb24"
        :cell-style="cellStyleFn"
      >
        <el-table-column label="ID" align="center" prop="id" width="70" />
        <el-table-column label="讨论组名称" align="center" prop="title" width="140" />
        <el-table-column label="讨论组类型" align="center" prop="type_name" width="100" />
        <el-table-column
          label="讨论主题"
          align="center"
          prop="theme"
          show-overflow-tooltip
        />
        <el-table-column label="发起人" align="center" prop="truename" />
        <el-table-column label="参与人数" align="center" prop="join_count" />

        <el-table-column label="发起时间" align="center" prop="createTime" width="140">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.create_time, "{y}-{m}-{d} {h}:{i}") }}</span>
          </template>
        </el-table-column>

        <el-table-column label="发言数量" align="center" prop="speak_count" />

        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="180"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleDetails(scope.row)"
              >查看</el-button
            >
            <el-button size="mini" type="text" @click="handleRelease(scope.row)">
              <span v-if="scope.row.speak_type === 1" key="speak_type-one">禁言</span
              ><span v-else key="speak_type-twe">解除禁言</span>
            </el-button>

            <el-button
              size="mini"
              type="text"
              @click="handleDelete(scope.row)"
              v-if="scope.row.type > 2"
              key="type-one"
              >解散</el-button
            >

            <el-button
              size="mini"
              type="text"
              @click="handleUpdate(scope.row)"
              v-if="scope.row.type > 2"
              key="type-twe"
              >管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="total !== 0"
      ></Pagination>
    </section>
    <!-- 讨论组详情 -->
    <DiscussDetail ref="detailsRef"></DiscussDetail>
    <!-- 管理/添加讨论组 -->
    <AddDiscussion
      ref="addDiscussionRef"
      @requestCommonFn="requestCommonFn"
    ></AddDiscussion>
  </div>
</template>

<script>
import {
  discussionHeader,
  DiscussionList,
  DiscussForbidden,
  DiscussDel,
} from "@/api/tearcher";
import DiscussDetail from "@/components/dialog/DiscussDetail";
import AddDiscussion from "@/components/dialog/AddDiscussion";
export default {
  data() {
    return {
      discussionHeaderData: {}, // 讨论组头部
      discussName: "",
      sendName: "",
      discussType: "",
      class_id: "",
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      postList: [], // 讨论组列表
      typeOptions: [
        { name: "默认", id: 1 },
        { name: "自建", id: 2 },
      ],
    };
  },
  components: {
    DiscussDetail,
    AddDiscussion,
  },
  methods: {
    // 修改某一列单元样式
    cellStyleFn({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 3) {
        return `text-align:left;`;
      }
    },
    // 重置页数
    resetPage() {
      this.currentPage = 1;
    },
    // 管理
    handleUpdate(row) {
      this.$refs.addDiscussionRef.operationDialog(row, this.class_id);
      // this.reset();
    },
    // 解散
    handleDelete(row) {
      const ids = row.id;
      this.$confirm("是否确认解散", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(function () {
          return DiscussDel({ id: ids });
        })
        .then(() => {
          this.requestCommonFn();
          this.messageTips("解散成功", "success");
        })
        .catch(function () {});
    },
    // 禁言
    handleRelease(row) {
      const ids = row.id;
      const no = row.speak_type === 1 ? "禁言" : "解除禁言";
      this.$confirm(`是否${no}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(function () {
          return DiscussForbidden({ id: ids, speak_type: Number(!row.speak_type) });
        })
        .then(() => {
          this.requestCommonFn();
          this.messageTips("修改成功", "success");
        })
        .catch(function () {});
    },
    // 查看
    handleDetails(row) {
      this.$nextTick(function () {
        this.$refs.detailsRef.operationDialog(row);
      });
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    //讨论组列表
    requestCommonFn() {
      DiscussionList({
        page: this.currentPage,
        limit: this.pageSize,
        class_id: this.class_id,
        title: this.discussName,
        username: this.sendName,
        type: this.discussType,
      }).then((res) => {
        this.postList = res.data.list;
        this.total = res.data.total;
      });
    },
    // 修改查询的值
    changeVal(val) {
      this.discussName = val.workName;
      this.sendName = val.modelVal;
      this.discussType = val.workPeople;
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 讨论组头部
      discussionHeader({ class_id: this.class_id }).then((res) => {
        this.discussionHeaderData = res.data;
      });
      this.requestCommonFn();
    },
  },
  created() {
    this.createFn();
  },
};
</script>

<style lang="less" scoped>
/deep/.my_search {
  .el-form-item {
    margin-left: 0;
    margin-right: 50px;
    &:nth-of-type(3) {
      margin-right: 0;
    }
  }
}
</style>
